import { Link } from '@remix-run/react'
import headshot from './mathieu353x326.jpg'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* TODO: Add Meta */}
			{/* <Helmet
        title="Mathieu Steele"
        meta={[
          {
            name: "description",
            content: "Hi, I'm Matt. I'm here to help with your insurance.",
          },
          {
            name: "keywords",
            content: "Mathieu Steele, Matt Steele",
          },
        ]}
      /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/about-us/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				About Us
			</Link>
			<br />
			<br />
			<h1 className="text-4xl font-black">Mathieu Steele</h1>
			<span className="image">
				<img
					src={headshot}
					alt="Mathieu Steele"
					className="max-w-md rounded-lg"
				/>
			</span>
			<br />
			<br />
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Hi! I'm Mathieu Steele. Many people call me Matt. Here are some fun
				facts about me:
				<ul>
					<li>I'm the oldest of nine Children.</li>
					<li>
						As a kid, I remember going on client visits with{' '}
						<Link
							to="/about-us/stan-steele/"
							className="text-blue-600 underline"
							prefetch="intent"
						>
							Grandpa Stan
						</Link>{' '}
						and my dad{' '}
						<Link
							to="/about-us/joel-steele/"
							className="text-blue-600 underline"
							prefetch="intent"
						>
							Joel Steele
						</Link>
						.
					</li>
					<li>
						I lived in Brazil for two years doing Christian missionary service
						there. I speak Portuguese (but I'm starting to get rusty).
					</li>
					<li>
						I studied Information Systems at{' '}
						<a href="https://byu.edu" target="_blank" rel="noopener noreferrer">
							Brigham Young University
						</a>{' '}
						and continue to work with technology to make life better.
					</li>
					<li>I have been a part of Stan Steele Agency since 2006.</li>
					<li>I live in Bloomfield with my wife and four daughters.</li>
				</ul>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<a
					href="https://calendly.com/mathieu-steele"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline"
				>
					Schedule an appointment with me (opens in a new tab)
				</a>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Connect with me on Social Media: <br /> <br />
				<ul className="icons">
					<li>
						<a
							href="https://www.facebook.com/mathieusteele"
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-600 underline"
						>
							<span className="label">Facebook (opens in a new tab)</span>
						</a>
					</li>
					<li>
						<a
							href="https://www.linkedin.com/in/mathieusteele/"
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-600 underline"
						>
							<span className="label">LinkedIn (opens in a new tab)</span>
						</a>
					</li>
				</ul>
			</p>
		</main>
	)
}

/*

    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
      There are many reasons why I look forward to going to work each morning.
      The primary reason for my workplace satisfaction is that I really enjoy
      the feeling I get when I help people.
    </p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>Insurance agents help people in many ways:</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>1. Obtaining insurance protection.</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>2. Understanding their options</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>3. Utilizing their coverage to make claims</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>4. Being with clients through transitionary phases of life</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>5. Helping people save money</p>

    */
